import * as Yup from 'yup';

const personVehicleRegistrationSchema = Yup.object({
  ptsVehicleID: Yup.number().nullable().required('A vehicle must be selected'),
});

export default personVehicleRegistrationSchema;
